module.exports = __webpack_public_path__ + "static/WEDDING E&M-80-daa2e83e44896f270c42ce6e9dfb8978.jpg";